module.exports = __webpack_public_path__ + "img/icon-plus-zwart.00ebbc169337db7219996c2736ae5ee0.svg";